import { render, staticRenderFns } from "./ExtractDetails.vue?vue&type=template&id=0cbc7891&scoped=true"
import script from "./ExtractDetails.vue?vue&type=script&lang=js"
export * from "./ExtractDetails.vue?vue&type=script&lang=js"
import style0 from "./ExtractDetails.vue?vue&type=style&index=0&id=0cbc7891&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc7891",
  null
  
)

export default component.exports